import { ReactElement } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CommunityConnectUserView from './UserTypes/CommunityConnectUser/CommunityConnectUserView';
import EpicCareLinkUserView from './UserTypes/EpicCareLinkUser/EpicCareLinkUserView';
import Home from './Home';
import { theme } from './_theme';
import { PAGE_IDS } from './_const';
import NonEmployeeCompletionForm from './NewNonEmployee_Completion_Form/NewNonEmployeeCompletionForm';
import EpicCareLinkDecline from './EpicCareLinkDecline/EpicCareLinkDecline';

/**
 * Routes for New Non-Employee Creation pages
 * @returns {ReactElement} React-router routes for New Non-Employee Creation pages
 */
const NewNonEmployeeRoutes = () => {
	const { path } = useRouteMatch();

	return (
		<ThemeProvider theme={theme}>
			<Switch>
				<Route
					path={`${path}/CommunityConnectUser`}
					exact
					render={props => (
						<CommunityConnectUserView
							key={PAGE_IDS.EPICCARE_LINK_USER}
							pageID={PAGE_IDS.EPICCARE_LINK_USER}
							{...props}
						/>
					)}
				/>
				<Route
					path={`${path}/EpicCareLinkUser`}
					exact
					render={props => (
						<EpicCareLinkUserView
							key={PAGE_IDS.EPICCARE_LINK_USER}
							pageID={PAGE_IDS.EPICCARE_LINK_USER}
							{...props}
						/>
					)}
				/>
				<Route
					path={`${path}/Home`}
					exact
					render={props => <Home {...props} />}
				/>
				<Route
					path={`${path}/CompletionForm/:msgID`}
					render={props => <NonEmployeeCompletionForm {...props} />}
				/>
				<Route
					path={`${path}/Decline`}
					render={() => <EpicCareLinkDecline />}
				/>
				<Route path={`${path}`}>
					<Redirect to={`${path}/Home`} />
				</Route>
				<Route path={`${path}/*`}>
					<Redirect to={`${path}/Home`} />
				</Route>
				<Route path='*'>404...</Route>
			</Switch>
		</ThemeProvider>
	);
};

export default NewNonEmployeeRoutes;
